export type CalendarReservationAccessLike = {
    contextDescription?: string | null;
};

export type CalendarReservationAccessWithContactTypes = {
    contactTypes?: readonly unknown[] | null;
};

export function getCalendarReservationAccessDescription(cra: CalendarReservationAccessLike): string | undefined {
    const { strip } = require('~/utils/markdown');
    return cra?.contextDescription ? strip(cra.contextDescription as string, '\n') : undefined;
}

export function isRemoteOnlyCRA(item: CalendarReservationAccessWithContactTypes): boolean {
    const contactTypes = item.contactTypes ?? [];
    const hasPhoneOrVideo = contactTypes.includes('PHONE') || contactTypes.includes('VIDEO');
    return hasPhoneOrVideo && !contactTypes.includes('VISIT');
}
